import styled from 'styled-components';

export const DivDashboardCardContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 2rem;
    margin: 0 5rem;
    &.active {
        max-height: 100%;
        opacity: 1;
        visibility: visible;
        transition: .5s ease;
    }
    &.inactive {
        max-height: 0;
        opacity: 0;
        visibility: hidden;
        transition: .1s ease;
    }
`

export const DivDashboardTableContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
`

export const SectionContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 2rem;
    h5 {
        margin: 1rem;
        text-decoration: underline;
    }
`

export const SectionTitle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const IconDown = styled.i`
    cursor: pointer;
    font-size: 1.3rem;
`

export const IconUp = styled.i`
    cursor: pointer;
    font-size: 1.3rem;
`

export const DivStartRemediation = styled.div`
    background: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.borderStrong};
    border-radius: ${(props) => props.theme.radius.sm};
    padding: 0.4rem 0.8rem;
    margin: 1.5rem 0.8rem;
    position: relative;
    height: 32px;
    display: flex;
    gap: 1rem;
    cursor: pointer;
    transition: background-color .12s ease;
    align-items: center;
    &:hover {
        background-color: ${(props) => props.theme.surface3};
    };
`

export const DivStartRemediationDisabled = styled.div`
    background: ${(props) => props.theme.surface2};
    border: 1px solid ${(props) => props.theme.border};
    border-radius: ${(props) => props.theme.radius.sm};
    padding: 0.4rem 0.8rem;
    margin: 1.5rem 0.8rem;
    position: relative;
    height: 32px;
    display: flex;
    gap: 1rem;
    cursor: not-allowed;
    align-items: center;
    opacity: 0.6;
`

/* ---- Barre de rafraîchissement ---- */

export const DivRefreshBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding: 8px 16px;
`

export const SpanLastFetched = styled.span`
    font-size: ${(props) => props.theme.type.caption};
    color: ${(props) => props.theme.text3};
`

export const ButtonRefresh = styled.button`
    border: 1px solid ${(props) => props.theme.borderStrong};
    border-radius: ${(props) => props.theme.radius.sm};
    padding: 0.4rem 1rem;
    height: 36px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: ${(props) => props.theme.surface};
    color: inherit;
    font-family: inherit;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.12s ease, opacity 0.12s ease;

    &:hover:not(:disabled) {
        background-color: ${(props) => props.theme.surface3};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`